const FUNDER = ['CCG', 'NHS England', 'Refering Organisation'];

type FUNDER = typeof FUNDER;

export default FUNDER;
